import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import ImageSlider from '../components/ImageSlider'; // Komponenta za slider
import '../css/style.css';

const TripsAndExcursions = () => {
  const { slug } = useParams();
  const [trips, setTrips] = useState([]); // Svi izleti
  const [categories, setCategories] = useState([{ name: 'All' }]); // Kategorije
  const [filteredTrips, setFilteredTrips] = useState([]); // Filterovani rezultati
  const [activeFilter, setActiveFilter] = useState('All'); // Aktivni filter
  const [sliderImages, setSliderImages] = useState([]); // Slike za slider
  const [coverImage, setCoverImage] = useState('/images/noimage.jpg'); // Fallback slika
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Dohvati sve izlete vezane za ovaj smeštaj
        const tripsResponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}/trips-excursions`
        );
        setTrips(tripsResponse.data);
        setFilteredTrips(tripsResponse.data); // Inicijalno svi podaci

        // Dohvati podatke za slider
        const accommodationResponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}`
        );

        console.log('Accommodation data:', accommodationResponse.data);

        const images = accommodationResponse.data.slider_images
          ? accommodationResponse.data.slider_images
              .split(';') // Pretvaranje stringa u niz
              .map((img) => `${process.env.REACT_APP_BACKEND_URL}/${img}`) // Dodavanje putanje
          : [];
        setSliderImages(images);

        const fallbackImage = accommodationResponse.data.cover_image
          ? `${process.env.REACT_APP_BACKEND_URL}/${accommodationResponse.data.cover_image}`
          : '/images/noimage.jpg';
        setCoverImage(fallbackImage);

        setLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to load trips.');
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
    if (filter === 'All') {
      setFilteredTrips(trips); // Prikazuje sve
    } else {
      setFilteredTrips(trips.filter((trip) => trip.category_name === filter));
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontFamily: 'Montserrat, sans-serif',
          backgroundColor: 'rgba(255, 255, 255, 0.7)', // Transparentna pozadina
        }}
      >
        <p style={{ fontSize: '20px', fontWeight: 'bold', margin: '0' }}>Loading...</p>
      </div>
    );
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (!trips.length) {
    return <p>No trips or excursions available for this accommodation.</p>;
  }

  return (
    <div className="trips-and-excursions-page">
    <div className="header-slider">
    {sliderImages.length > 0 ? (
        <ImageSlider images={sliderImages} />
    ) : (
        <div
        className="header-image"
        style={{
            backgroundImage: `url(${coverImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '300px',
            width: '100vw', // Širina preko celog ekrana
            margin: '0', // Ukloni margine
        }}
        />
    )}
    <div className="page-title-container">
        <h1 className="page-title">Trips and Excursions</h1>
    </div>
    </div>


      <div className="content-boxed">
        <div className="breadcrumb-container">
          <p className="breadcrumb">
            <Link to={`/accommodations/${slug}`} className="breadcrumb-link">
              Home
            </Link>
            <span className="breadcrumb-divider"> &gt; </span>
            <span className="current-page">Trips and Excursions</span>
          </p>
        </div>

        {/* Filter dugmadi */}
        <div className="filter-section">
          {categories.map((category, index) => (
            <button
              key={index}
              className={category.name === activeFilter ? 'active' : ''}
              onClick={() => handleFilterChange(category.name)}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Prikazivanje izleta */}
        <div className="gallery">
          {filteredTrips.map((trip, index) => (
            <Link
              to={`/accommodations/${slug}/trips-excursions/${trip.id}`}
              className="gallery-item"
              key={index}
            >
              <img
                src={
                  trip.image
                    ? `${process.env.REACT_APP_BACKEND_URL}/${trip.image}`
                    : '/images/noimage.jpg'
                }
                alt={trip.title || 'No title available'}
              />
              <div className="trip-info">
                <h3>{trip.name || 'No name available'}</h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TripsAndExcursions;
